import { LicenseDetails } from '@microsoft/microsoft-graph-types';

// noinspection JSUnusedGlobalSymbols
export enum LicenseSKU {
  TeamsEnterpriseE1 = 'STANDARDPACK',
  TeamsEnterpriseE3 = 'ENTERPRISEPACK',
  TeamsEnterpriseE5 = 'ENTERPRISEPREMIUM',
  TeamsEnterpriseE5NoConference = 'ENTERPRISEPREMIUM_NOPSTNCONF',
  TeamsExploratory = 'TEAMS_EXPLORATORY',
  PSTN = 'MCOEV',
  ExchangeBStandard = 'EXCHANGE_B_STANDARD',
  ExchangeLStandard = 'EXCHANGE_L_STANDARD',
  ExchangeLArchive = 'EXCHANGE_S_ARCHIVE',
  ExchangeSDeskless = 'EXCHANGE_S_DESKLESS',
  ExchangeSEnterprise = 'EXCHANGE_S_ENTERPRISE',
  ExchangeSEssentials = 'EXCHANGE_S_ESSENTIALS',
  ExchangeSStandard = 'EXCHANGE_S_STANDARD',
  ExchangeSStandardMidmarket = 'EXCHANGE_S_STANDARD_MIDMARKET',
  ExchangeSFoundation = 'EXCHANGE_S_FOUNDATION',
}

export const ExchangeLicenses = [
  LicenseSKU.ExchangeBStandard,
  LicenseSKU.ExchangeLStandard,
  LicenseSKU.ExchangeLArchive,
  LicenseSKU.ExchangeSDeskless,
  LicenseSKU.ExchangeSEnterprise,
  LicenseSKU.ExchangeSEssentials,
  LicenseSKU.ExchangeSStandard,
  LicenseSKU.ExchangeSStandardMidmarket,
  LicenseSKU.ExchangeSFoundation,
];

export enum ServicePlans {
  TeamGeneral = 'TEAMS',
}

export type LicenseValidator = (license: LicenseDetails[]) => boolean;

const teamsLicenses = [
  LicenseSKU.TeamsEnterpriseE1,
  LicenseSKU.TeamsEnterpriseE3,
  LicenseSKU.TeamsEnterpriseE5,
  LicenseSKU.TeamsExploratory,
];

export const calendarLicenseRequirements: LicenseValidator = (licenses: LicenseDetails[]) =>
  licenses.some((license) =>
    license.servicePlans.some(
      (servicePlan) => ExchangeLicenses.includes(servicePlan.servicePlanName as LicenseSKU) && servicePlan.provisioningStatus === 'Success',
    ),
  );
export const teamsLicenseRequirements: LicenseValidator = (licenses: LicenseDetails[]) =>
  licenses.some(
    (l) =>
      teamsLicenses.includes(l.skuPartNumber as LicenseSKU) ||
      l.servicePlans.some((servicePlan) => servicePlan.servicePlanName.startsWith(ServicePlans.TeamGeneral)),
  );
export const pstnLicenseRequirements: LicenseValidator = (licenses: LicenseDetails[]) =>
  teamsLicenseRequirements(licenses) &&
  licenses.some(
    (l) =>
      l.skuPartNumber.startsWith(LicenseSKU.PSTN) ||
      l.servicePlans.some((servicePlan) => servicePlan.servicePlanName.startsWith(LicenseSKU.PSTN)) ||
      l.skuPartNumber === LicenseSKU.TeamsEnterpriseE5,
  );

export interface ContactLicenseCapability {
  teams: boolean;
  pstn: boolean;
  calendar: boolean;
}
